import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(() => ({
  // Wrapper to display `StopTime` component as `block`.
  // TODO: remove after fix component in
  // https://github.com/busbud/design-system/issues/1111
  stopTime: {
    display: "flex"
  }
}));
